// Shared chrome for one settings section: a heading, an explanatory line, and
// a card body. Keeps the five sections visually identical so the screen reads
// as one page rather than five bolted-together widgets.
//
// RTL: no directional utilities anywhere in here. Spacing is symmetric
// (`space-y`, `gap`) or logical, so the section mirrors for free.

import { Card } from '@fajrarabi/ui';
import type { ReactNode } from 'react';

export function AccountSection({
  id,
  title,
  description,
  tone = 'default',
  children,
}: {
  id: string;
  title: string;
  description?: string;
  /** 'danger' tints the border for the irreversible section. */
  tone?: 'default' | 'danger';
  children: ReactNode;
}) {
  const headingId = `${id}-heading`;
  return (
    <section aria-labelledby={headingId} className="mt-10 first:mt-0">
      <h2 id={headingId} className="text-lg font-semibold text-ink-900">
        {title}
      </h2>
      {description && <p className="mt-1 max-w-prose text-sm text-ink-500">{description}</p>}
      <Card className={tone === 'danger' ? 'mt-4 ring-2 ring-heart/30' : 'mt-4'}>
        <div className="space-y-4">{children}</div>
      </Card>
    </section>
  );
}
